module.exports = __webpack_public_path__ + "img/logo.63e5e3c1.png";